module.exports = __webpack_public_path__ + "1a7edf44246039e0a0db8f6999c2a250.svg";